import React, { useState, useEffect } from "react";

import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import IconPublish from '@material-ui/icons/Publish';
import IconSend from '@material-ui/icons/Send';


import { Create } from 'react-admin';
import { Show } from 'react-admin';
import { Edit } from 'react-admin';
import { TopToolbar, Button} from 'react-admin';
import { SimpleShowLayout, TextField, DateField, RichTextField, ReferenceManyField } from 'react-admin';
import { SimpleForm, SelectInput, TextInput, DateInput, EditButton, required } from 'react-admin';

import App from '../../../../app.js';


export const ERC20TokenCreate = (props) => {
	const type = (props.location && props.location.state && props.location.state.ctx && props.location.state.ctx.type ? props.location.state.ctx.type : 'create');


	const renderImport = () => {
		return (		
		<Create title='Import Ethereum ERC20Token' {...props}>
			<SimpleForm>
				<TextInput source="description" validate={[required()]} />
				<TextInput source="address" validate={[required()]} />
			</SimpleForm>
		</Create>
		);
	};

	const renderCreate = () => {
		return (		
			<Create title='Create Ethereum ERC20Token' {...props}>
			<SimpleForm>
				<TextInput source="description" validate={[required()]} />
				<TextInput source="name" validate={[required()]} />
				<TextInput source="symbol" validate={[required()]} />
				<TextInput source="decimals" validate={[required()]} />
				<TextInput source="totalsupply" validate={[required()]}  />
			</SimpleForm>
		</Create>
		);
	};
	
	const render = () => {
		return (
			<>
			{(type === 'import' ? renderImport() : renderCreate())}
			</>
		);
	};

	return (render());
};


const ERC20TokenShowActions = ({ basePath, data, resource }) => {
	const id = (data ? data.id : null);

	const renderLocalToken = () => {
		return (
			<Button
				label="Deploy"
				component={Link}
				to={{
					pathname: '/erc20tokens/'+ (id ? id : '') + '/show',
					state: { ctx: { type: 'deploy' } },
				}}
				>
					<IconPublish/>
			</Button>
		);
	};

	const renderChainToken = () => {
		return (
			<Button
				label="Transfer"
				component={Link}
				to={{
					pathname: '/erc20tokens/'+ (id ? id : '') + '/show',
					state: { ctx: { type: 'transfer' } },
				}}
				>
					<IconSend/>
			</Button>
		);
	};

	const render = () => {
		return (
			<TopToolbar>
				{data && data.isLocalOnly ? renderLocalToken() : renderChainToken()}
				<EditButton basePath={basePath} record={data} />
			</TopToolbar>
		);
	};

	return (render());

};

const NameField = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [field, setField] = useState({value: theapp.t('loading')});

	const fetchValue = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		if (record.isLocalOnly)
			return mvcmydashboard.t('not deployed yet');
		else 
			return mvcmydashboard.getERC20TokenName(sessionuuid, record.uuid);
	};

	useEffect(() => {
		fetchValue().then(value => {setField({value});}).catch(err => {});

		return () => {
		};
	}, [props.value]);

	return (<TextField label="name" record={field} source="value" />);
};

const WalletInput = (props) => {
	const { record } = props;
	const theapp = App.getAppObject();

	const [choices, setChoices] = useState([]);

	const fetchChoices = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession();
		let bRefresh = true;
		let bIncludeReadOnly = false;

		let accounts = await mvcmydashboard.getSessionAccounts(sessionuuid, bRefresh, bIncludeReadOnly);

		let choices = [];

		for (var i = 0; i < (accounts ? accounts.length : 0); i++) {
			choices.push({id: accounts[i].uuid, name: accounts[i].address});
		}

		return choices;
	};

	useEffect(() => {
		fetchChoices().then(choices => {setChoices(choices);}).catch(err => {});

		return () => {
		};
	}, [props.value]);

	return (<SelectInput label="Wallet used" source="from" choices={choices} />);
};


export const ERC20TokenShow = (props) => {
	const type = (props.location && props.location.state && props.location.state.ctx && props.location.state.ctx.type ? props.location.state.ctx.type : 'show');

	const renderShow = () => {
		return (
			<Show title='Ethereum ERC20Token' actions={<ERC20TokenShowActions />} {...props}>
				<SimpleShowLayout>
					<><Typography variant="h6">local</Typography></>
					<TextField label="description" source="localdescription" />
					<TextField label="uuid" source="uuid" />
					<TextField label="contract address" source="address" />
					<TextField label="token name" source="localname" />
					<TextField label="token symbol" source="localsymbol" />
					<TextField label="token decimals" source="localdecimals" />
					<TextField label="token total supply" source="localtotalsupply" />
					<TextField label="status" source="statusstring" />
					<TextField label="web3 provider url" source="web3providerurl" />
					<TextField label="chain id" source="chainid" />
					<TextField label="networkd id" source="networkid" />
					<><Typography variant="h6">on chain</Typography></>
					<TextField source="totalsupply" />
					<NameField />
					<TextField source="totalsupply" />
				</SimpleShowLayout>
			</Show>
		);
	};

	const renderDeploy = () => {

		return (
			<>
			<Edit title='Deploy Ethereum ERC20Token' {...props}>
				<SimpleForm>
					<WalletInput />
					<TextInput source="wallet" validate={[required()]} />
					<TextInput source="gas" validate={[required()]} />
					<TextInput source="gasprice" validate={[required()]} />
				</SimpleForm>
			</Edit>

			<Show title='Ethereum ERC20Token' actions={<ERC20TokenShowActions />} {...props}>
				<SimpleShowLayout>
					<><Typography variant="h6">local</Typography></>
					<TextField label="description" source="localdescription" />
					<TextField label="uuid" source="uuid" />
					<TextField label="contract address" source="address" />
					<TextField label="token name" source="localname" />
					<TextField label="token symbol" source="localsymbol" />
					<TextField label="token decimals" source="localdecimals" />
					<TextField label="token total supply" source="localtotalsupply" />
					<TextField label="status" source="statusstring" />
					<TextField label="web3 provider url" source="web3providerurl" />
					<TextField label="chain id" source="chainid" />
					<TextField label="networkd id" source="networkid" />
					<><Typography variant="h6">on chain</Typography></>
					<TextField source="totalsupply" />
					<NameField />
					<TextField source="totalsupply" />
				</SimpleShowLayout>
			</Show>

			</>
		);
	};
	
	const renderTransfer = () => {

		return (
			<div>Transfer</div>
		);
	};

	const render = () => {
		switch(type) {
			case 'deploy':
				return renderDeploy();
			case 'transfer':
				return renderTransfer();
			default:
				return renderShow();
		}
	};
	
	return (render());

};

export const ERC20TokenEdit = (props) => {
	const theapp = App.getAppObject();

	const [isLocalOnly, setIsLocalOnly] = useState(false);

	useEffect(() => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		mvcmydashboard.getCurrentSession()
		.then(sessionuuid => {
			return mvcmydashboard.getERC20TokenFromUUID(sessionuuid, props.id);
		})
		.then(erc20token => {
			setIsLocalOnly(erc20token.isLocalOnly);
		})
		.catch(err => {});

		return () => {
		};
	}, [props.isLocalOnly]);

	const renderLocalEdit = () => {
		return (
			<Edit title='Modify Ethereum ERC20Token' {...props}>
				<SimpleForm>
					<Typography variant="h6">local</Typography>
					<TextInput source="localdescription" validate={[required()]} />
					<TextInput source="localname" validate={[required()]} />
					<TextInput source="localsymbol" validate={[required()]} />
					<TextInput source="localdecimals" validate={[required()]} />
					<TextInput source="localtotalsupply" validate={[required()]} />
					<TextField source="uuid" />
					<TextField source="address" />
					<TextField source="statusstring" />
					<TextField source="web3providerurl" />
					<TextField source="chainid" />
					<TextField source="networkid" />
					<Typography variant="h6">on chain</Typography>
					<TextField source="totalsupply" />
				</SimpleForm>
			</Edit>
		);

	};

	const renderChainEdit = () => {
		return (
			<Edit title='Modify Ethereum ERC20Token' {...props}>
				<SimpleForm>
					<Typography variant="h6">local</Typography>
					<TextInput source="localdescription" validate={[required()]} />
					<TextField source="localname" />
					<TextField source="localsymbol" />
					<TextField source="localdecimals" />
					<TextField source="localtotalsupply" />
					<TextField source="uuid" />
					<TextField source="address" />
					<TextField source="statusstring" />
					<TextField source="web3providerurl" />
					<TextField source="chainid" />
					<TextField source="networkid" />
					<Typography variant="h6">on chain</Typography>
					<TextField source="totalsupply" />
				</SimpleForm>
			</Edit>
		);

	};


	const render = () => {
		if (isLocalOnly)
			return renderLocalEdit();
		else
			return renderChainEdit();
	};

	return (render());

};


